export enum TaxSettingCustomerAddress {
  HEAD_OFFICE = "head_office",
  TERMINAL_LOCATION = "terminal_location",
}

export enum TaxComponents {
  TAX_SETTINGS = "tax-settings",
  TAX_REGISTRATIONS = "tax-registrations",
}

export enum TaxCategory {
  PHYSICAL = "physical",
  SERVICES = "services",
  DIGITAL = "digital",
  GENERAL = "general",
  DEFAULT = "default",
}

export enum TaxBehavior {
  EXCLUSIVE = "exclusive",
  INCLUSIVE = "inclusive",
  UNSPECIFIED = "unspecified",
  INFERRED_BY_CURRENCY = "inferred_by_currency",
}

export enum TaxType {
  PHYSICAL = "physical",
  DIGITAL = "digital",
  SERVICES = "services",
  DEFAULT = "default",
}

export enum TaxAddressSource {
  BILLING = "billing",
  SHIPPING = "shipping",
}
